import { DreamBlock } from '@typedream/core';
import { createTElementPluginFactory } from '../../plate';
import {
  ELEMENT_COLUMN_ITEM,
  ELEMENT_IMAGE,
  ELEMENT_MEDIA_EMBED,
} from '../../pluginKeys';
import { ColumnItemElementEditor } from './components/ColumnItemElement';
import { withColumnItem } from './withColumnItem';

export const createColumnItemPlugin = createTElementPluginFactory({
  key: ELEMENT_COLUMN_ITEM,
  component: ColumnItemElementEditor,
  options: {
    meta: {
      title: 'Column Item',
    },
    format: {
      formatType: 'block',
      turnInto: [],
      focusableWhenEmpty: false,
      validProperties: ['width'],
    },
    overrideChildOptions: (child: DreamBlock) => {
      if ([ELEMENT_IMAGE, ELEMENT_MEDIA_EMBED].includes(child.type)) {
        return {};
      }

      return {
        isResizable: false,
      };
    },
  },
  withOverrides: withColumnItem,
});
